import Header from './components/header/header';
import Menu from './components/menu/menu';
import { Outlet } from 'react-router-dom';
import Footer from './components/footer/footer';

function HeaderFooterLayout() {
  return (
    <>
      <header>
        <Header />
        <Menu />
      </header>
      <main>
        <Outlet />
      </main>
      <footer>
        <Footer />
      </footer>
    </>
  );
}

export default HeaderFooterLayout;
